import { RootState } from '../../store/reducers';
import { DashboardRankingDto } from './dahboards.dto';

export const selectActiveRankings = (state: RootState): DashboardRankingDto[] => state.dashboard.activeRankings;

export const selectUpcomingRankings = (state: RootState): DashboardRankingDto[] => state.dashboard.upcomingRankings;
